/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";

function Basic() {
  const navigate = useNavigate();

  const [rememberMe, setRememberMe] = useState(false);

  const [selectedCode, setSelectedCode] = useState("+91");
  const [mobile, setMobile] = useState("");
  const [userType, setUserType] = useState("employee");

  const countryCodes = [
    { code: "+91", label: "🇮🇳" },
    { code: "+1", label: "🇺🇸" },
    { code: "+44", label: "🇬🇧" },
    { code: "+61", label: "🇦🇺" },
    // Add more as needed
  ];

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleContinue = () => {
    navigate("/authentication/verify-otp", {
      state: {
        mobile: mobile,
        code: selectedCode,
        type: userType,
      },
    });
  };

  const handleUserTypeChange = (event) => {
    setUserType(event.target.value);
  };

  return (
    <BasicLayout bgColor="info" image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          // borderRadius="xl"
          coloredShadow="info"
          // mx={2}
          // mt={-3}
          p={3}
          mb={1}
          textAlign="center"
          sx={{
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
          }}
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Log in to JITO JOBS VADODARA
          </MDTypography>

          {/* <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <FacebookIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GitHubIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GoogleIcon color="inherit" />
              </MDTypography>
            </Grid>
          </Grid> */}
        </MDBox>
        <MDBox pt={3} px={3}>
          <FormControl component="fieldset">
            <RadioGroup row name="user-type" value={userType} onChange={handleUserTypeChange}>
              <FormControlLabel
                value="employee"
                control={<Radio color="primary" />}
                label="Employee"
                sx={{ mr: 3 }}
              />
              <FormControlLabel
                value="employer"
                control={<Radio color="primary" />}
                label="Employer"
              />
            </RadioGroup>
          </FormControl>
        </MDBox>
        <MDBox pt={3} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2} display="flex" gap={1}>
              {/* <FormControl sx={{ minWidth: 80,  }}>
                <InputLabel>Code</InputLabel>
                <Select
                  value={selectedCode}
                  label="Code"
                  onChange={(e) => setSelectedCode(e.target.value)}
                >
                  {countryCodes.map((country) => (
                    <MenuItem key={country.code} value={country.code}>
                      {country.label} {country.code}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
              <MDInput
                select
                label="Code"
                value={selectedCode}
                onChange={(e) => setSelectedCode(e.target.value)}
                sx={{ minWidth: 80 }}
                InputProps={{ sx: { height: "44px" } }}
              >
                {countryCodes.map((country) => (
                  <MenuItem key={country.code} value={country.code}>
                    {country.label} {country.code}
                  </MenuItem>
                ))}
              </MDInput>
              <MDInput
                type="mobile"
                label="Mobile Number"
                fullWidth
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </MDBox>
            {/* <MDBox mb={2}>
              <MDInput type="password" label="Password" fullWidth />
            </MDBox> */}
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth onClick={handleContinue}>
                Continue
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                By continuing further, you are agreeing to our{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Terms and Conditions
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
